<template>
    <div class="flex items-center gap-2 pl-2 xl:gap-3 xl:pl-3">
        <div
            v-tooltip.bottom="'Přepněte do češtiny'"
            class="flex h-7 w-7 cursor-pointer items-center justify-center rounded-full border border-black-text text-xs text-black-text duration-150 hover:bg-black-text hover:text-white"
            :class="{
                'pointer-events-none bg-black-text text-white': locale === 'cs',
            }"
            @click="switchLanguage('cs')"
        >
            CZ
        </div>
        <div
            v-tooltip.bottom="'Switch to English'"
            class="flex h-7 w-7 cursor-pointer items-center justify-center rounded-full border border-black-text text-xs text-black-text duration-150 hover:bg-black-text hover:text-white"
            :class="{
                'pointer-events-none bg-black-text text-white': locale === 'en',
            }"
            @click="switchLanguage('en')"
        >
            EN
        </div>
    </div>
</template>

<script setup lang="ts">
const { locale, setLocale } = useI18n()
const localePath = useLocalePath()
const store = useMainStore()
const route = useRoute()

function switchLanguage(lang: LanguageCode) {
    setLocale(lang)
    store.mobileMenuOpen = false
    if (route.name?.toString().includes("texty-kody")) {
        navigateTo(localePath("/texty"))
    }
}
</script>

<style scoped></style>
